import { IGenericAutoComplete } from "../../_common/interface/autocomplete/iStandardAutocomplete";
import { dropdownService } from "../../_services/dropdown.service";
import StandardAutoComplete from "./standard.autocomplete";

export const DataTypeAutoComplete = (params: IGenericAutoComplete) => {

    return (

        <StandardAutoComplete
            {...params}
            itemsLoader={() => dropdownService.fetchData(params.dataType, +(params.parentId || 0))}
            parentId={+(params.parentId || 0)}
        />
    );
}